import { PlayerEvent } from "../Core/PlayerEvents";

/**
 * Engine events forwarded into plugins + plugin bus.
 * Uses PlayerEvent (PascalCase) + legacy lowercase only.
 * Platform aliases (READY/PLAY/…) are dual-published by the Event Bus;
 * plugins that need them should subscribe via engine.getEventBus() or
 * rely on PlayerEvent aliases (PlayerEvent.PLAY === PlaybackStarted).
 */
export var PLUGIN_FORWARDED_EVENTS = [
  "statechange",
  "timeupdate",
  "ended",
  "error",
  "recovered",
  "sourcechange",
  "durationchange",
  "canplay",
  "volumechange",
  "ratechange",
  PlayerEvent.PLAYER_READY,
  PlayerEvent.PLAYBACK_STARTED,
  PlayerEvent.PLAYBACK_PAUSED,
  PlayerEvent.PLAYBACK_STOPPED,
  PlayerEvent.PLAYBACK_ENDED,
  PlayerEvent.BUFFER_STARTED,
  PlayerEvent.BUFFER_ENDED,
  PlayerEvent.SEEK_STARTED,
  PlayerEvent.SEEK_COMPLETED,
  PlayerEvent.QUALITY_CHANGED,
  PlayerEvent.PLAYBACK_ERROR,
  PlayerEvent.SOURCE_CHANGED,
  PlayerEvent.STATE_CHANGED,
  PlayerEvent.TIME_UPDATE,
  PlayerEvent.VOLUME_CHANGED,
  PlayerEvent.MUTE_CHANGED,
  PlayerEvent.RATE_CHANGED,
  PlayerEvent.FULLSCREEN_CHANGED,
  PlayerEvent.FULLSCREEN_ENTER,
  PlayerEvent.FULLSCREEN_EXIT,
  PlayerEvent.PROVIDER_CHANGED,
  PlayerEvent.TEXT_TRACK_SELECTED,
  PlayerEvent.AUDIO_TRACK_SELECTED,
];

export default PLUGIN_FORWARDED_EVENTS;
